module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Workflows")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-new-workflow",
      "to": {
        name: 'WorkflowDetail'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Novo")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('b-form-select', {
    staticClass: "input-sm",
    attrs: {
      "options": [{
        text: 5,
        value: 5
      }, {
        text: 10,
        value: 10
      }, {
        text: 15,
        value: 15
      }]
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite para pesquisar"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "workflow-table",
      "items": _vm.workflows,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "active",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n          " + _vm._s(item.value ? 'Ativo' : 'Inativo') + "\n      ")])
      }
    }, {
      key: "target",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n          " + _vm._s(item.value ? item.value.description : '') + "\n      ")])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('span', {}, [_c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'WorkflowDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-edit"
        }), _vm._v(" Editar\n          ")])], 1)
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": this.workflows.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12b02112"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkflowList.vue
// module id = 1434
// module chunks = 1